import request from 'utils/request';

const PREFIX = '/api/billing/aff/';

export const AffiliateBillingAPI = {
  LIST: PREFIX + 'list',
  ADD: PREFIX + 'add',
  UPDATE: PREFIX + 'update',
  DELETE: PREFIX,
  DOWNLOAD: PREFIX + 'download',
  PAYMENT_STATUS: PREFIX + 'receipt-status',
  RECONCILIATION_PROGRESS: PREFIX + 'reconciliation-progress',
};

export function getAffiliateBillingList(data) {
  return request({
    url: AffiliateBillingAPI.LIST,
    method: 'post',
    data,
  });
}

export function getPaymentStatusList() {
  return request({
    url: AffiliateBillingAPI.PAYMENT_STATUS,
    method: 'get',
  });
}

export function getReconciliationProgressList() {
  return request({
    url: AffiliateBillingAPI.RECONCILIATION_PROGRESS,
    method: 'get',
  });
}

export function addAffiliateBilling(data) {
  return request({
    url: AffiliateBillingAPI.ADD,
    method: 'post',
    data,
  });
}

export function deleteAffiliateBillingById(id) {
  return request({
    url: AffiliateBillingAPI.DELETE + id,
    method: 'delete',
  });
}

export function updateAffiliateBilling(data) {
  return request({
    url: AffiliateBillingAPI.UPDATE,
    method: 'put',
    data,
  });
}

export function downloadAffiliateBilling(data) {
  return request({
    url: AffiliateBillingAPI.DOWNLOAD,
    method: 'post',
    responseType: 'blob',
    data,
  });
}
